export function getNumberOfDays() {
  let year = new Date().getFullYear();
  if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) return 366;
  return 365;
}

export function dateTimeString(date: Date | string | number, locale?: Intl.LocalesArgument): string | null {
  if (date === null || date === undefined || date === '') {
    return null;
  }

  const parsedDate = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  // Omitting the locale lets the browser apply the user's regional date and time preferences.
  return parsedDate.toLocaleString(locale, { dateStyle: 'short', timeStyle: 'short' });
}
